/**
 * ChatGPT Ads does not append utm_*; it only adds `oppref` (click id).
 * Map that onto the UTM fields company.utm already stores.
 * Explicit utm_source always wins — never overwrite a real campaign.
 */

export const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
export const UTM_STORAGE_KEY = "rb_utm";

export const CHATGPT_ADS_UTM = {
  utm_source: "chatgpt",
  utm_medium: "cpc",
  utm_campaign: "chatgpt_ads",
};

export function utmFromSearch(search = "") {
  const params = new URLSearchParams(search.startsWith("?") || search === "" ? search : `?${search}`);
  const utm = {};
  UTM_KEYS.forEach((key) => {
    const value = params.get(key);
    if (value) utm[key] = value;
  });

  const oppref = params.get("oppref");
  if (oppref && !utm.utm_source) {
    Object.assign(utm, CHATGPT_ADS_UTM);
  }

  return Object.keys(utm).length > 0 ? utm : null;
}

export function readStoredUtm() {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(UTM_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function storeUtmParams(search = typeof window !== "undefined" ? window.location.search : "") {
  const utm = utmFromSearch(search);
  if (!utm) return;
  try {
    localStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(utm));
  } catch {
    // storage full or unavailable
  }
}

/** URL (including ChatGPT `oppref`) first, then last captured landing/app UTM. */
export function getUtmParams(search = typeof window !== "undefined" ? window.location.search : "") {
  const fromUrl = utmFromSearch(search);
  if (fromUrl) {
    storeUtmParams(search);
    return fromUrl;
  }
  return readStoredUtm();
}
